import React, { useState } from "react";
import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  InputNumber,
  Typography,
  Alert,
} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { useTranslation } from "react-i18next";
import useData from "../../../../hooks/useData";

const { Option } = Select;
const { Title } = Typography;

const TelegramExpenseAdd = () => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  dayjs.locale(language);
  const { update, isMutating } = useData(`/products/finance`, []);

  const [form] = Form.useForm();
  const [status, setStatus] = useState(null); // Состояние для статуса (успех/ошибка)

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        const expenseData = {
          price: values.amount,
          transactionType: values.transactionType,
          type: "outcome",
          date: values.date.format("YYYY-MM-DD"),
          contractId: values.description,
        };
        await update(expenseData);
        setStatus({
          type: "success",
          message: "Расход успешно добавлен",
        });
        form.resetFields();
      })
      .catch((e) => {
        console.error(e);
        setStatus({
          type: "error",
          message: "Заполните все обязательные поля",
        });
      });
  };

  return (
    <div style={{ maxWidth: 400, margin: "0 auto", padding: "20px" }}>
      <script src={"https://telegram.org/js/telegram-web-app.js"} />
      <Title level={3} style={{ textAlign: "center" }}>
        Добавить расход
      </Title>

      {status && (
        <Alert
          message={status.message}
          type={status.type}
          showIcon
          style={{ marginBottom: 10 }}
        />
      )}

      <Form
        form={form}
        layout="vertical"
        initialValues={{
          date: dayjs(),
          transactionType: "cash",
        }}
      >
        <Form.Item
          label="Дата"
          name="date"
          rules={[{ required: true, message: "Выберите дату" }]}
        >
          <DatePicker style={{ width: "100%" }} maxDate={dayjs()} />
        </Form.Item>

        <Form.Item
          label="Сумма"
          name="amount"
          rules={[{ required: true, message: "Введите сумму" }]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Тип транзакции"
          name="transactionType"
          rules={[{ required: true, message: "Выберите тип" }]}
        >
          <Select>
            <Option value="cash">Наличные</Option>
            <Option value="bank">Банк</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Описание"
          name="description"
          rules={[{ required: true, message: "Введите описание" }]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>

        <Button
          type="primary"
          block
          onClick={handleSubmit}
          loading={isMutating}
        >
          Добавить
        </Button>
      </Form>
    </div>
  );
};

export default TelegramExpenseAdd;
